module.exports = __webpack_public_path__ + "img/mach.bade84d.png";